/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Brand;
(function (Brand) {
    Brand["UNKNOWN"] = "UNKNOWN";
    Brand["WIX"] = "WIX";
    Brand["EDITORX"] = "EDITORX";
})(Brand = exports.Brand || (exports.Brand = {}));
var CType;
(function (CType) {
    CType["STRING"] = "STRING";
    CType["CORD"] = "CORD";
    CType["STRING_PIECE"] = "STRING_PIECE";
})(CType = exports.CType || (exports.CType = {}));
var ComparatorTypeEnum;
(function (ComparatorTypeEnum) {
    ComparatorTypeEnum["UNKNOWN"] = "UNKNOWN";
    ComparatorTypeEnum["EQUAL"] = "EQUAL";
    ComparatorTypeEnum["CONTAINED_IN"] = "CONTAINED_IN";
    ComparatorTypeEnum["CONTAINS_SOME"] = "CONTAINS_SOME";
    ComparatorTypeEnum["CONTAINS_NONE"] = "CONTAINS_NONE";
    ComparatorTypeEnum["NOT_CONTAINS"] = "NOT_CONTAINS";
    ComparatorTypeEnum["NOT_CONTAINED_IN"] = "NOT_CONTAINED_IN";
    ComparatorTypeEnum["BE_NOTHING"] = "BE_NOTHING";
    ComparatorTypeEnum["EXISTS"] = "EXISTS";
    ComparatorTypeEnum["MORE_THAN_DAYS"] = "MORE_THAN_DAYS";
    ComparatorTypeEnum["WITHIN_DAYS"] = "WITHIN_DAYS";
    ComparatorTypeEnum["LESS"] = "LESS";
    ComparatorTypeEnum["LESS_EQUAL"] = "LESS_EQUAL";
    ComparatorTypeEnum["GREATER"] = "GREATER";
    ComparatorTypeEnum["GREATER_EQUAL"] = "GREATER_EQUAL";
    ComparatorTypeEnum["SIZE_LESS_EQUAL"] = "SIZE_LESS_EQUAL";
    ComparatorTypeEnum["SIZE_GREATER_EQUAL"] = "SIZE_GREATER_EQUAL";
    ComparatorTypeEnum["NOT_EQUAL"] = "NOT_EQUAL";
})(ComparatorTypeEnum = exports.ComparatorTypeEnum || (exports.ComparatorTypeEnum = {}));
var ConnectedDomainCriteriaEnum;
(function (ConnectedDomainCriteriaEnum) {
    ConnectedDomainCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    ConnectedDomainCriteriaEnum["CONNECTED"] = "CONNECTED";
    ConnectedDomainCriteriaEnum["NOT_CONNECTED"] = "NOT_CONNECTED";
})(ConnectedDomainCriteriaEnum = exports.ConnectedDomainCriteriaEnum || (exports.ConnectedDomainCriteriaEnum = {}));
var CriteriaType;
(function (CriteriaType) {
    CriteriaType["UNKNOWN"] = "UNKNOWN";
    CriteriaType["COMPOUND"] = "COMPOUND";
    CriteriaType["CUSTOM"] = "CUSTOM";
    CriteriaType["GEO"] = "GEO";
    CriteriaType["LANGUAGE"] = "LANGUAGE";
    CriteriaType["USER_ROLE"] = "USER_ROLE";
    CriteriaType["USER_STATUS"] = "USER_STATUS";
    CriteriaType["USER_COLORS"] = "USER_COLORS";
    CriteriaType["USER_GUIDS"] = "USER_GUIDS";
    CriteriaType["TEMPLATE_GUIDS"] = "TEMPLATE_GUIDS";
    CriteriaType["POST_REG"] = "POST_REG";
    CriteriaType["CONNECTED_DOMAIN"] = "CONNECTED_DOMAIN";
    CriteriaType["PREMIUM_PLAN"] = "PREMIUM_PLAN";
    CriteriaType["EXCLUDE_IN_SALE"] = "EXCLUDE_IN_SALE";
    CriteriaType["MAILBOX"] = "MAILBOX";
    CriteriaType["CONNECTED_OFFERING_GROUP"] = "CONNECTED_OFFERING_GROUP";
    CriteriaType["INSTALLED_APPS"] = "INSTALLED_APPS";
    CriteriaType["PRODUCT_GROUPS"] = "PRODUCT_GROUPS";
    CriteriaType["DOMAIN_LENGTH"] = "DOMAIN_LENGTH";
    CriteriaType["MAILBOX_SALE"] = "MAILBOX_SALE";
    CriteriaType["VOUCHERS"] = "VOUCHERS";
    CriteriaType["FREE_SITE"] = "FREE_SITE";
    CriteriaType["BRAND"] = "BRAND";
    CriteriaType["SAVED_AUDIENCE"] = "SAVED_AUDIENCE";
})(CriteriaType = exports.CriteriaType || (exports.CriteriaType = {}));
var CustomFilterDataSource;
(function (CustomFilterDataSource) {
    CustomFilterDataSource["UNKNOWN"] = "UNKNOWN";
    CustomFilterDataSource["USER_PROFILE"] = "USER_PROFILE";
    CustomFilterDataSource["SITE_PROFILE"] = "SITE_PROFILE";
})(CustomFilterDataSource = exports.CustomFilterDataSource || (exports.CustomFilterDataSource = {}));
var Exposure;
(function (Exposure) {
    Exposure["PRIVATE"] = "PRIVATE";
    Exposure["INTERNAL"] = "INTERNAL";
    Exposure["PUBLIC"] = "PUBLIC";
})(Exposure = exports.Exposure || (exports.Exposure = {}));
var Format;
(function (Format) {
    Format["EMAIL"] = "EMAIL";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["IPV4"] = "IPV4";
    Format["IPV6"] = "IPV6";
    Format["URI"] = "URI";
    Format["WEB_URL"] = "WEB_URL";
    Format["PHONE"] = "PHONE";
    Format["CREDIT_CARD"] = "CREDIT_CARD";
    Format["GUID"] = "GUID";
    Format["COUNTRY"] = "COUNTRY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["LOCAL_DATE"] = "LOCAL_DATE";
    Format["LOCAL_TIME"] = "LOCAL_TIME";
    Format["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
})(Format = exports.Format || (exports.Format = {}));
var FreeSiteCriteriaEnum;
(function (FreeSiteCriteriaEnum) {
    FreeSiteCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    FreeSiteCriteriaEnum["HAS_FREE"] = "HAS_FREE";
    FreeSiteCriteriaEnum["NO_FREE"] = "NO_FREE";
})(FreeSiteCriteriaEnum = exports.FreeSiteCriteriaEnum || (exports.FreeSiteCriteriaEnum = {}));
var IdempotencyLevel;
(function (IdempotencyLevel) {
    IdempotencyLevel["IDEMPOTENCY_UNKNOWN"] = "IDEMPOTENCY_UNKNOWN";
    IdempotencyLevel["NO_SIDE_EFFECTS"] = "NO_SIDE_EFFECTS";
    IdempotencyLevel["IDEMPOTENT"] = "IDEMPOTENT";
})(IdempotencyLevel = exports.IdempotencyLevel || (exports.IdempotencyLevel = {}));
var JSType;
(function (JSType) {
    JSType["JS_NORMAL"] = "JS_NORMAL";
    JSType["JS_STRING"] = "JS_STRING";
    JSType["JS_NUMBER"] = "JS_NUMBER";
})(JSType = exports.JSType || (exports.JSType = {}));
var Label;
(function (Label) {
    Label["LABEL_OPTIONAL"] = "LABEL_OPTIONAL";
    Label["LABEL_REQUIRED"] = "LABEL_REQUIRED";
    Label["LABEL_REPEATED"] = "LABEL_REPEATED";
})(Label = exports.Label || (exports.Label = {}));
var MailboxCriteriaEnum;
(function (MailboxCriteriaEnum) {
    MailboxCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    MailboxCriteriaEnum["HAS_MAILBOX"] = "HAS_MAILBOX";
    MailboxCriteriaEnum["NO_MAILBOX"] = "NO_MAILBOX";
})(MailboxCriteriaEnum = exports.MailboxCriteriaEnum || (exports.MailboxCriteriaEnum = {}));
var Maturity;
(function (Maturity) {
    Maturity["ALPHA"] = "ALPHA";
    Maturity["BETA"] = "BETA";
    Maturity["IA"] = "IA";
    Maturity["GA"] = "GA";
})(Maturity = exports.Maturity || (exports.Maturity = {}));
var Operator;
(function (Operator) {
    Operator["UNKNOWN"] = "UNKNOWN";
    Operator["OR"] = "OR";
    Operator["AND"] = "AND";
})(Operator = exports.Operator || (exports.Operator = {}));
var OperatorValueTypeEnum;
(function (OperatorValueTypeEnum) {
    OperatorValueTypeEnum["UNKNOWN"] = "UNKNOWN";
    OperatorValueTypeEnum["NUMBER"] = "NUMBER";
    OperatorValueTypeEnum["STRING"] = "STRING";
    OperatorValueTypeEnum["LIST"] = "LIST";
    OperatorValueTypeEnum["TIMESTAMP"] = "TIMESTAMP";
    OperatorValueTypeEnum["BOOLEAN"] = "BOOLEAN";
})(OperatorValueTypeEnum = exports.OperatorValueTypeEnum || (exports.OperatorValueTypeEnum = {}));
var OptimizeMode;
(function (OptimizeMode) {
    OptimizeMode["SPEED"] = "SPEED";
    OptimizeMode["CODE_SIZE"] = "CODE_SIZE";
    OptimizeMode["LITE_RUNTIME"] = "LITE_RUNTIME";
})(OptimizeMode = exports.OptimizeMode || (exports.OptimizeMode = {}));
var PersonType;
(function (PersonType) {
    PersonType["USER"] = "USER";
    PersonType["SITEMEMBER"] = "SITEMEMBER";
    PersonType["VISITOR"] = "VISITOR";
})(PersonType = exports.PersonType || (exports.PersonType = {}));
var Plan;
(function (Plan) {
    Plan["UNKNOWN"] = "UNKNOWN";
    Plan["PREMIUM"] = "PREMIUM";
    Plan["NONE"] = "NONE";
})(Plan = exports.Plan || (exports.Plan = {}));
var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    Status["ALL"] = "ALL";
    Status["WIX_EMPLOYEE"] = "WIX_EMPLOYEE";
})(Status = exports.Status || (exports.Status = {}));
var Type;
(function (Type) {
    Type["TYPE_DOUBLE"] = "TYPE_DOUBLE";
    Type["TYPE_FLOAT"] = "TYPE_FLOAT";
    Type["TYPE_INT64"] = "TYPE_INT64";
    Type["TYPE_UINT64"] = "TYPE_UINT64";
    Type["TYPE_INT32"] = "TYPE_INT32";
    Type["TYPE_FIXED64"] = "TYPE_FIXED64";
    Type["TYPE_FIXED32"] = "TYPE_FIXED32";
    Type["TYPE_BOOL"] = "TYPE_BOOL";
    Type["TYPE_STRING"] = "TYPE_STRING";
    Type["TYPE_GROUP"] = "TYPE_GROUP";
    Type["TYPE_MESSAGE"] = "TYPE_MESSAGE";
    Type["TYPE_BYTES"] = "TYPE_BYTES";
    Type["TYPE_UINT32"] = "TYPE_UINT32";
    Type["TYPE_ENUM"] = "TYPE_ENUM";
    Type["TYPE_SFIXED32"] = "TYPE_SFIXED32";
    Type["TYPE_SFIXED64"] = "TYPE_SFIXED64";
    Type["TYPE_SINT32"] = "TYPE_SINT32";
    Type["TYPE_SINT64"] = "TYPE_SINT64";
})(Type = exports.Type || (exports.Type = {}));
var UserRoleCriteriaEnum;
(function (UserRoleCriteriaEnum) {
    UserRoleCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    UserRoleCriteriaEnum["OWNER"] = "OWNER";
    UserRoleCriteriaEnum["NOT_OWNER"] = "NOT_OWNER";
})(UserRoleCriteriaEnum = exports.UserRoleCriteriaEnum || (exports.UserRoleCriteriaEnum = {}));
var UserStatusCriteriaEnum;
(function (UserStatusCriteriaEnum) {
    UserStatusCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    UserStatusCriteriaEnum["NEW"] = "NEW";
})(UserStatusCriteriaEnum = exports.UserStatusCriteriaEnum || (exports.UserStatusCriteriaEnum = {}));
